import { Quill } from 'react-quill';

const Inline = Quill.import('blots/inline');

export class FoundTextBlot extends Inline {
  static blotName = 'found-text';
  static className = 'rb-found-text';
  static tagName = 'div';
}

export class FoundTextCurrentBlot extends Inline {
  static blotName = 'found-text-current';
  static className = 'rb-found-text-current';
  static tagName = 'div';
  static dataAttrName = 'data-found-id';

  static create(value: string) {
    let node: HTMLElement = super.create();
    if (value) {
      node.setAttribute(this.dataAttrName, value);
      node.tabIndex = -1;
    }
    return node;
  }
}
